import React from 'react';

import { PageId } from 'utils/ubi/pageId';
import assemblePath from 'utils/assemblePath';

import InternalLink, { HrefFunction, LinkProps } from './InternalLink';

const childCategoryLinkBuilderFactory =
  (parentCategorySlug: string, childCategorySlug: string): HrefFunction =>
  (market, verticalParam) =>
    assemblePath(market, verticalParam, parentCategorySlug, childCategorySlug);

interface CategoryLinkProps extends LinkProps {
  parentCategorySlug: string;
  childCategorySlug: string;
}

const ChildCategoryLink = ({ parentCategorySlug, childCategorySlug, ...props }: CategoryLinkProps) => {
  return (
    <InternalLink
      toPage={PageId.OldChildCategory}
      hrefFun={childCategoryLinkBuilderFactory(parentCategorySlug, childCategorySlug)}
      {...props}
    />
  );
};

export default ChildCategoryLink;
